import React from 'react';

const PlanDeComBdcOptionsFields = ({
  options,
  values,
  disabled = false,
  onChange,
}) => {
  const updateField = (field, value) => {
    onChange?.({ ...values, [field]: value });
  };

  return (
    <div className="pdc-bdc-options">
      <div>
        <label className="form-label" htmlFor="pdc-bdc-titre">Titre du document</label>
        <select
          id="pdc-bdc-titre"
          className="form-select form-select-sm"
          value={values.document_titre}
          onChange={(e) => updateField('document_titre', e.target.value)}
          disabled={disabled}
        >
          {(options.titres ?? []).map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="form-label" htmlFor="pdc-bdc-mode">Mode de règlement</label>
        <select
          id="pdc-bdc-mode"
          className="form-select form-select-sm"
          value={values.mode_reglement}
          title={values.mode_reglement}
          onChange={(e) => updateField('mode_reglement', e.target.value)}
          disabled={disabled}
        >
          {(options.modes_reglement ?? []).map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="form-label" htmlFor="pdc-bdc-facturation">Facturation</label>
        <select
          id="pdc-bdc-facturation"
          className="form-select form-select-sm"
          value={values.facturation}
          title={values.facturation}
          onChange={(e) => updateField('facturation', e.target.value)}
          disabled={disabled}
        >
          {(options.facturations ?? []).map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="form-label" htmlFor="pdc-bdc-conditions">Conditions de règlement</label>
        <select
          id="pdc-bdc-conditions"
          className="form-select form-select-sm"
          value={values.conditions_reglement}
          title={values.conditions_reglement}
          onChange={(e) => updateField('conditions_reglement', e.target.value)}
          disabled={disabled}
        >
          {(options.conditions_reglement ?? []).map((option) => (
            <option key={option} value={option}>{option}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PlanDeComBdcOptionsFields;
